import React, { Component } from 'react';

import {
  NavbarDashboard,
  NavDesktop,
  NavMobile
} from '../nav-bar';
import Footer from '../footer';

import './styles.scss';

function layout(WrappedComponent) {
  return class extends Component {
    render() {
      return (
        <React.Fragment>
          <div className="layout">
            <NavDesktop />
            <NavMobile />
            <div className="layout-wrapper">
              <div className="layout-container">
                <NavbarDashboard />
                <WrappedComponent />
              </div>
              <Footer />
            </div>
          </div>
        </React.Fragment>
      );
    }
  }
}

export default layout;
